import { Box, SxProps, Theme, Typography, useTheme } from '@mui/material'
import React from 'react'

interface Props {
    isActive?: boolean
    handleClickFunc?: () => void
    title?: string | null
    fonWeight?: number
    fontColor?: string
    icon?: JSX.Element
    sx?: SxProps<Theme>
}

const RectangleElement = ({
    isActive,
    handleClickFunc,
    title,
    icon,
    fonWeight,
    fontColor,
    sx,
}: Props) => {
    const theme = useTheme()
    const customFontColor = fontColor ? fontColor : 'white'
    const customFontWeight = fonWeight ? fonWeight : '500'
    const containerStyle = {
        display: 'flex',
        alignItems: 'center',
        border: !isActive ? '1px solid' : null,
        borderColor: 'custom.darkGray',
        background: isActive ? '#F55960' : 'temporary',
        borderRadius: theme.shape.borderRadius,
        padding: icon ? '7px 15px' : '10px 18px',
        '&:hover': {
            cursor: 'pointer',
            opacity: !isActive ? '0.7' : 1,
        },
    }
    const textStyle = {
        color: isActive ? 'white' : customFontColor,
        typography: 'text2',
        fontWeight: isActive ? '700' : customFontWeight,
    }

    return (
        <Box sx={{ ...containerStyle, ...sx }} onClick={handleClickFunc}>
            <Typography sx={textStyle}>{title}</Typography>
            {icon}
        </Box>
    )
}

export { RectangleElement }
